document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('size-guide-modal');
  const btn = document.getElementById('size-guide-btn');
  const span = document.querySelector('.close-modal');

  if (btn && modal && span) {
    btn.onclick = function () {
      modal.style.display = "block";
    };

    span.onclick = function () {
      modal.style.display = "none";
    };

    window.onclick = function (event) {
      if (event.target === modal) {
        modal.style.display = "none";
      }
    };
  }
});
